import { useState } from "react";
import { api, errorMsg } from "@/lib/api";
import { useAuth } from "@/lib/auth";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { KeyRound } from "lucide-react";

export default function CambioPasswordObligatorio() {
  const { setUser, logout } = useAuth();
  const [actual, setActual] = useState("");
  const [nueva, setNueva] = useState("");
  const [confirmar, setConfirmar] = useState("");
  const [cargando, setCargando] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (nueva.length < 6) { toast.error("La nueva contraseña debe tener al menos 6 caracteres"); return; }
    if (nueva !== confirmar) { toast.error("Las contraseñas no coinciden"); return; }
    setCargando(true);
    try {
      await api.post("/auth/cambiar-password", { password_actual: actual, password_nueva: nueva });
      const { data } = await api.get("/auth/me");
      setUser(data);
      toast.success("Contraseña actualizada. ¡Bienvenido!");
    } catch (err) { toast.error(errorMsg(err)); }
    finally { setCargando(false); }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-secondary p-6">
      <form onSubmit={submit} data-testid="cambio-obligatorio-form"
        className="w-full max-w-sm space-y-4 bg-white border border-border rounded-sm p-6 shadow-sm">
        <div className="flex items-center gap-2">
          <div className="bg-primary text-primary-foreground p-2 rounded-sm"><KeyRound size={20} /></div>
          <div>
            <h1 className="font-heading text-lg font-bold">Defina su nueva contraseña</h1>
            <p className="text-xs text-muted-foreground">Su contraseña fue reseteada por un administrador. Debe cambiarla para continuar.</p>
          </div>
        </div>
        <div className="space-y-1.5">
          <Label htmlFor="pw-actual">Contraseña temporal (actual)</Label>
          <Input id="pw-actual" data-testid="cambio-obligatorio-actual" type="password" value={actual}
            onChange={(e) => setActual(e.target.value)} autoComplete="current-password" required autoFocus />
        </div>
        <div className="space-y-1.5">
          <Label htmlFor="pw-nueva">Nueva contraseña</Label>
          <Input id="pw-nueva" data-testid="cambio-obligatorio-nueva" type="password" value={nueva}
            onChange={(e) => setNueva(e.target.value)} autoComplete="new-password" required minLength={6} />
        </div>
        <div className="space-y-1.5">
          <Label htmlFor="pw-confirmar">Confirmar nueva contraseña</Label>
          <Input id="pw-confirmar" data-testid="cambio-obligatorio-confirmar" type="password" value={confirmar}
            onChange={(e) => setConfirmar(e.target.value)} autoComplete="new-password" required minLength={6} />
        </div>
        <Button data-testid="cambio-obligatorio-submit" type="submit" className="w-full" disabled={cargando}>
          {cargando ? "Guardando..." : "Cambiar contraseña y continuar"}
        </Button>
        <button type="button" onClick={logout} data-testid="cambio-obligatorio-logout"
          className="w-full text-center text-xs text-muted-foreground hover:text-foreground">
          Cerrar sesión
        </button>
      </form>
    </div>
  );
}
